import type { Message } from '@fim/futurex-protocol';
import type { ScoredRecord } from '@fim/futurex-vector';
import type { Chunk } from '@fim/futurex-context';
import type { Retriever } from './index-store.js';

function renderChunks(hits: ScoredRecord<Chunk>[]): string {
  return hits
    .map((h) => `// ${h.payload.path}:${h.payload.startLine}-${h.payload.endLine}\n${h.payload.text}`)
    .join('\n\n');
}

/**
 * Insert a retrieved-context message immediately before the latest user message.
 * It is added only to the messages sent for THIS turn (never stored in history),
 * so the pinned cached prefix stays byte-identical and context refreshes per turn.
 */
export async function augmentMessages(
  messages: Message[],
  retriever: Retriever | null,
  topK: number,
): Promise<Message[]> {
  if (!retriever || retriever.size === 0 || topK <= 0) return messages;

  let idx = -1;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i]?.role === 'user') {
      idx = i;
      break;
    }
  }
  if (idx < 0) return messages;

  const query = messages[idx]?.content ?? '';
  const hits = await retriever.retrieve(query, topK);
  if (hits.length === 0) return messages;

  const contextMessage: Message = {
    role: 'user',
    content: `Relevant repository code (retrieved for this question):\n\n${renderChunks(hits)}`,
  };
  return [...messages.slice(0, idx), contextMessage, ...messages.slice(idx)];
}
